import React from 'react'
import { Image } from 'react-bootstrap';

export const ImageLayout = ({...otherProps}) => <Image {...otherProps} />;